import * as React from 'react'
import { Dispatch } from 'redux'
import { connect } from 'react-redux'
import { PlayerCapabilities } from 'ATVWebPlayer'
import { MessageTypes } from '@amzn/dvui/dist/Block'
import { clickToX1 } from '@utils'
import {
  playerConfigDataSelector,
  whisperCacheDataSelector,
  autoplaySelector
} from '../../selectors/player'
import { IDetailPageState } from '../../reducers'
import {
  PlayerIntegration,
  PlayerContentConfig,
  PlaybackContentLink
} from '@shared/player'
import {
  playerClosedOrTitleChanged,
  setPlayerCapabilities,
  startPlayback
} from '../../actions/player'
import { DetailPageActions, DetailPageActionTypes } from '../../actions'
import { createBanner } from '../../actions/banner'
import { StringId } from '../localizer/stringId'

export type Props = ReturnType<typeof mapStateToProps> &
  ReturnType<typeof mapDispatchToProps>

const onClosed = (content: PlayerContentConfig) => {
  playerClosedOrTitleChanged(content, true)
}

const onAsinChanged = (content: PlayerContentConfig) => {
  playerClosedOrTitleChanged(content, false)
}

export const PlayerConnected = ({
  setPlayerCapabilities,
  startPlayback,
  createError,
  ...props
}: Props) => {
  const onPlayerCapabilities = (capabilities: PlayerCapabilities) => {
    clickToX1()
    setPlayerCapabilities(capabilities)
    const { autoplay } = props
    if (autoplay) {
      setTimeout(() => {
        startPlayback(autoplay)
      })
    }
  }

  const liveIncompatibleCallback = () =>
    createError(StringId.DV_WEB_LIVE_NOT_SUPPORTED_BODY)

  const integrationProps = {
    ...props,
    onAsinChanged,
    onClosed,
    liveIncompatibleCallback,
    onPlayerCapabilities
  }
  return <PlayerIntegration {...integrationProps} />
}
const mapStateToProps = (state: IDetailPageState) => ({
  playerConfig: playerConfigDataSelector(state),
  whisperCacheData: whisperCacheDataSelector(state),
  playbackLinkData: state.player.playbackLinkData || undefined,
  autoplay: autoplaySelector(state)
})

const mapDispatchToProps = (dispatch: Dispatch<DetailPageActions>) => ({
  setPlayerCapabilities: (capabilities: PlayerCapabilities) =>
    dispatch(setPlayerCapabilities(capabilities)),
  onPlayFailure: () => {
    dispatch({ type: DetailPageActionTypes.PlaybackFailed })
  },
  startPlayback: (playbackLinkData: PlaybackContentLink) =>
    dispatch(startPlayback(playbackLinkData)),
  createError: (stringId: StringId) =>
    dispatch(createBanner({ type: MessageTypes.error, stringId }))
})

export const Player = connect(
  mapStateToProps,
  mapDispatchToProps
)(PlayerConnected)
